<table class="fancy-scrollbar-newUI fancy-scrollbar-small">
    <thead>
        <tr>
            <th class="wk-rsh-from">{{ "AuditTrail.From" | translate }}</th>
            <th class="wk-rsh-to">{{ "AuditTrail.To" | translate }}</th>
            <th class="wk-rsh-user">{{ "AuditTrail.User" | translate }}</th>
            <th class="wk-rsh-datetime">{{ "AuditTrail.MadeOn" | translate }}</th>
        </tr>
    </thead>
    <tbody>
        @for (status of statuses(); track $index) {
            @if (!status.hide) {
                <tr [class]="'wk-rsh-row' + $index">
                    <td class="wk-rsh-from">
                        @if (statuses()[$index + 1]) {
                            <div class="truncate" (mouseover)="showTooltip($event)" (focus)="showTooltip($event)">
                                {{ (statuses()[$index + 1].TaxReturn ? statuses()[$index + 1].TaxReturn.Name : "General.None") | wkTranslate }}
                            </div>

                            @if (showReturnHistoryTooltips) {
                                <tooltip-pds3
                                    position="right"
                                    [openDelay]="600"
                                    [closeDelay]="50"
                                    [targetSelector]="'.wk-rsh-row' + $index + ' .wk-rsh-from .truncate'"
                                >
                                    {{ (statuses()[$index + 1]?.TaxReturn ? statuses()[$index + 1]?.TaxReturn?.Name : "General.None") | wkTranslate }}
                                </tooltip-pds3>
                            }
                        }
                    </td>
                    <td class="wk-rsh-to">
                        <div class="truncate" (mouseover)="showTooltip($event)" (focus)="showTooltip($event)">
                            {{ (status.TaxReturn ? status.TaxReturn.Name : "General.None") | wkTranslate }}
                        </div>

                        @if (showReturnHistoryTooltips) {
                            <tooltip-pds3
                                position="right"
                                [openDelay]="600"
                                [closeDelay]="50"
                                [targetSelector]="'.wk-rsh-row' + $index + ' .wk-rsh-to .truncate'"
                            >
                                {{ (status?.TaxReturn ? status?.TaxReturn?.Name : "General.None") | wkTranslate }}
                            </tooltip-pds3>
                        }
                    </td>

                    <td class="wk-rsh-user">
                        <div class="truncate" (mouseover)="showTooltip($event)" (focus)="showTooltip($event)">
                            {{ status.userName }}
                        </div>

                        @if (showReturnHistoryTooltips) {
                            <tooltip-pds3
                                position="right"
                                [openDelay]="600"
                                [closeDelay]="50"
                                [targetSelector]="'.wk-rsh-row' + $index + ' .wk-rsh-user .truncate'"
                            >
                                {{ status.userName }}
                            </tooltip-pds3>
                        }
                    </td>

                    <td class="wk-rsh-datetime">
                        {{ status?.statusDate != null ? (status?.statusDate * 1000 | date: dateFormat() : undefined : 'en-US') : "" }}
                    </td>
                </tr>
            }
        }
    </tbody>
</table>
